module.exports = __webpack_public_path__ + "img/5-5.604c3e9b.svg";